/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IContentBlockViewProps } from '@msdyn365-commerce-modules/content-block';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { IContentBlockProps } from '../definition-extensions/content-block.ext.props.autogenerated';

const ContentBlockView: React.FC<IContentBlockViewProps & IContentBlockProps<{}>> = props => {
    const {
        contentBlockContainer,
        imageContainer,
        detailsContainer,
        title,
        text,
        links,
        image,
        contentBlockAnchorTag,
        imageLink,
        imageAriaLabel
    } = props;

    const { additionalParagraph } = props.config;

    const contentBlockAdditionalText = additionalParagraph && (
        <Node className='ms-content-block__additionaltext'>
            <Msdyn365.RichTextComponent text={additionalParagraph} />
        </Node>
    );

    if (imageLink) {
        return (
            <Module {...contentBlockContainer}>
                <Node
                    {...contentBlockAnchorTag}
                    href={imageLink}
                    className={contentBlockAnchorTag ? contentBlockAnchorTag.className : ''}
                    aria-label={imageAriaLabel}
                >
                    <Node {...imageContainer}>{image}</Node>
                </Node>
                <Node {...detailsContainer}>
                    {title}
                    {text}
                    {links}
                    {contentBlockAdditionalText}
                </Node>
            </Module>
        );
    } else {
        return (
            <Module {...contentBlockContainer}>
                <Node {...imageContainer}>{image}</Node>
                <Node {...detailsContainer}>
                    {title}
                    {text}
                    {links}
                    {contentBlockAdditionalText}
                </Node>
            </Module>
        );
    }
};

export default ContentBlockView;
